import { action, computed, makeObservable, observable } from 'mobx';
import type { UnitGpsDto } from '@mark43/cad-api';
import type { GeoPoint } from '../location/types';

export class UnitLocationStore {
    @observable
    private unitGpsLocation: UnitGpsDto = {} as UnitGpsDto;
    @observable
    private unitCurrentLocation: GeoPoint | undefined = undefined;

    constructor() {
        makeObservable(this);
    }

    @action
    setUnitGpsLocation(unitGpsLocation: UnitGpsDto) {
        this.unitGpsLocation = unitGpsLocation;
    }

    @action
    setUnitLocation(unitLocation: GeoPoint | undefined) {
        this.unitCurrentLocation = unitLocation;
    }

    @computed
    get unitGpsInfo() {
        return this.unitGpsLocation;
    }

    @computed
    get unitLocation() {
        return this.unitCurrentLocation;
    }
}
